import * as types from "./actionType";

export const enableLoader = () => {
	return { type: types.ENABLE_LOADER };
}
export const disableLoader = () => {
	return { type: types.DISABLE_LOADER };
}

export const disableLoaderWithError = () => {
	return { type: types.DISABLE_LOADER_WITH_ERROR };
}

export const disablePayModal = () => {
	return { type: types.DISABLE_PAYMODAL };
}
export const showPayModal = () => {
	return { type: types.SHOW_PAYMODAL };
}
export const hidePayModal = () => {
	return { type: types.HIDE_PAYMODAL };
}

export const showPayVeil = () => {
    return { type: types.SHOW_PAYVEIL };
}

export const hidePayVeil = () => {
    return { type: types.HIDE_PAYVEIL };
}

export const openPayModal = accountNumber => {
	return { type: types.SET_CURRENT_ACCOUNT, accountNumber };
}
export const openPolicyPayModal = policyNumber => {
	return { type: types.SET_CURRENT_POLICY, policyNumber };
}


// WEBPACK FOOTER //
// ./src/actions/uiActions.js